import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { queryKeys } from "@/lib/query-keys";

export function useRecentDownloads(assetId: string | undefined, days = 30) {
  return useQuery({
    queryKey: queryKeys.assets.recentDownloads(assetId!, days),
    queryFn: async () => {
      if (!assetId) return 0;
      const { data, error } = await supabase.rpc("get_recent_download_count" as any, {
        p_asset_id: assetId,
        p_days: days,
      });
      if (error) return 0;
      return (data as number) || 0;
    },
    enabled: !!assetId,
    staleTime: 1000 * 60 * 5,
  });
}
